<template>
  <div class="container mx-auto">
    <div class="px-4 py-3">
      <div class="px-2 py-2 bg-white borderd">
        <div class="flex items-center items-justify">
          <form class="relative block w-full px-0 py-2 mb-1 bg-white" @submit.prevent="search()">
            <div class="absolute inset-y-0 flex items-center pl-2 left-4">
              <svg class="w-4 h-4 text-gray-600 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.32 14.9l1.1 1.1c.4-.02.83.13 1.14.44l3 3a1.5 1.5 0 0 1-2.12 2.12l-3-3a1.5 1.5 0 0 1-.44-1.14l-1.1-1.1a8 8 0 1 1 1.41-1.41l.01-.01zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
              </svg>
            </div>
            <input v-model="filter.searchvalue" class="block w-64 py-1 pl-8 pr-4 form-input" placeholder="sök..." />
          </form>
          <div class="relative flex w-24 text-sm">
            Antal {{ count }}
          </div>
          <div class="relative flex">
            <createapidlg />
          </div>
        </div>

        <table class="w-full table-fixed">
          <tr class="border-b">
            <td class="px-4 py-2 text-gray-600 uppercase w-72">namn</td>
            <td class="px-4 py-2 text-gray-600 uppercase">visningsnamn</td>
            <td class="w-20 px-4 py-2" />
          </tr>

          <tbody>
            <tr v-for="a in list" :key="a.id" class="bg-white">
              <td class="px-4 py-2 text-gray-900">{{ a.name}}</td>
              <td class="px-4 py-2 text-gray-900">{{ a.displayName }}</td>
              <td class="w-32 px-4 py-2 text-center align-middle">
                <router-link :to="{
                    name: 'apiresource',
                    params: { id: a.id }
                  }" class="w-full focus:outline-none">
                  <div class="mt-1 ml-1 text-gary-100">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="w-4 h-4 text-gray-600 fill-current hover:text-blue-500" viewBox="0 0 20 20">
                      <path d="M10 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
                    </svg>
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <InfiniteLoading :identifier="infiniteId" @infinite="infiniteHandler" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import CreateApiDlg from "./CreateApiDlg";

export default {
  name: "apisgrid",
  components: { createapidlg: CreateApiDlg, InfiniteLoading },
  data() {
    return {
      currentPage: 0,
      infiniteId: +new Date(),
      filter: { searchvalue: "", limit: 20, offset: 0 }
    };
  },
  computed: {
    ...mapGetters("apiresourcesStore", ["list", "count", "pages"])
  },

  methods: {
    ...mapActions("apiresourcesStore", ["fetchList"]),

    async load() {
      this.filter.offset = this.filter.limit * (this.currentPage - 1);
      await this.fetchList(this.filter);
      this.infiniteId += 1;
    },

    async search() {
      this.currentPage = 0;
      this.infiniteId += 1;
    },

    async infiniteHandler($state) {
      this.currentPage++;
      await this.load();
      $state.loaded();

      if (this.currentPage === this.pages) {
        $state.complete();
      }
    }
  }
};
</script>
